import * as types from 'types'

import { storeItemsTransactor, storeItemsMerger, storeChildTypeRanker, deepMerge } from 'reducers/z_redux_helpers'

import { v4 as uuidv4 } from 'uuid'
import _groupBy from 'lodash.groupBy'
import _merge from 'lodash.merge'
import moment from 'moment'

const FALSY_LOADERS = {
	create: false,
	read: false,
	update: false,
	delete: false,
}

const INITIAL_STATE = {
	data: [],
	symptomTypes: {
		data: [],
		used: [],
		loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
	},
	daysEvents: {},
	current: {},
	searchCache: {
		symptomTypes: {},
	},
	loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
}

// flattens the symptom types join model through the symptom types model
// entity = new object
// symtomEntitiesMap = stored object (if exists)
const symptomDecorator = (entity, symtomEntitiesMap) => {
	return symtomEntitiesMap.map((entityMap) => {
		entityMap.object = {
			...entityMap.object,
			...entity,
			types: (entity.types && entity.types.length
				? entity.types.map((type) => ({
						id: type.id,
						name: type.name,
						intensity: type.SymptomTypesLists ? type.SymptomTypesLists.intensity : null,
						symptom_id: type.SymptomTypesLists ? type.SymptomTypesLists.symptom_id : null,
						symptom_type_id: type.SymptomTypesLists ? type.SymptomTypesLists.symptom_type_id : null,
				  }))
				: []
			).map((type) => {
				if (!type._app) {
					type._app = {}
					type._app.uuid = uuidv4()
				}
				return type
			}),
		}
		entityMap.object._app = {
			...entityMap.object._app,
			synced: true,
		}
		return entityMap
	})
}

const symptomUnsyncedDecorator = (entity, symtomEntitiesMap) => {
	return symtomEntitiesMap.map((entityMap) => {
		entityMap.object = {
			...entityMap.object,
			...entity,
			types: (entity.types || []).map((type) => {
				if (!type._app) {
					type._app = {}
					type._app.uuid = uuidv4()
				}
				return type
			}),
		}
		entityMap.object._app = {
			...entityMap.object._app,
			synced: false,
		}
		return entityMap
	})
}

const symptomTypeDecorator = (entity, symptomTypeEntitiesMap) => {
	return symptomTypeEntitiesMap.map((entityMap) => {
		entityMap.object = {
			...entityMap.object,
			...entity,
		}
		entityMap.object._app = {
			...entityMap.object._app,
			synced: true,
		}
		if (!entityMap.object._app.uuid) {
			entityMap.object._app.uuid = uuidv4()
		}
		return entityMap
	})
}

const symptomTypeUnsyncedDecorator = (entity, symptomTypeEntitiesMap) => {
	return symptomTypeEntitiesMap.map((entityMap) => {
		entityMap.object = {
			...entityMap.object,
			...entity,
		}
		entityMap.object._app = {
			...entityMap.object._app,
			synced: false,
		}
		if (!entityMap.object._app.uuid) {
			entityMap.object._app.uuid = uuidv4()
		}
		return entityMap
	})
}

export default (state = JSON.parse(JSON.stringify(INITIAL_STATE)), action) => {
	switch (action.type) {
		case types.PURGE:
			return JSON.parse(JSON.stringify(INITIAL_STATE))

		// GET SYMPTOMS
		case types.GET_SYMPTOMS_SUCCESS:
			const events = storeItemsMerger(
				state.data,
				action.payload.symptoms
					.map((entity) => {
						return storeItemsTransactor(
							state,
							'data',
							entity,
							{
								id: entity.id,
							},
							symptomDecorator
						)
					})
					.reduce((acc, current) => acc.concat(current), [])
			)
			return {
				...state,
				data: events,
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(state.symptomTypes.data, 'types', state.data, [
						'id',
						'name',
						'creator_id',
						'migration_id',
						'_app',
					]),
					used: [...action.payload.symptoms, ...state.data].reduce((acc, entity) => {
						acc = entity.types ? [...acc, ...entity.types.map((type) => type.id)] : acc
						return acc
					}, []),
				},
				daysEvents: _merge(
					{},
					state.daysEvents,
					_groupBy(events, (item) => {
						return moment(item.occurred_at).format('YYYY-MM-DD')
					})
				),
			}

		case types.GET_SYMPTOMS_SUCCESS_COMPLETE:
			return {
				...state,
				loading: {
					...state.loading,
					read: false,
				},
			}

		case types.GET_SYMPTOMS_FAIL:
			return {
				...state,
				loading: {
					...state.loading,
					read: false,
				},
			}
		case types.GET_SYMPTOMS:
			return {
				...state,
				loading: {
					...state.loading,
					read: true,
				},
			}

		// UPDATE SYMPTOM
		case types.UPDATE_SYMPTOM_SUCCESS:
			return {
				...state,
				data: storeItemsMerger(
					state.data,
					storeItemsTransactor(
						state,
						'data',
						action.payload,
						{
							id: action.payload.id,
						},
						symptomDecorator
					)
				),
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(state.symptomTypes.data, 'types', state.data, [
						'id',
						'name',
						'creator_id',
						'migration_id',
						'_app',
					]),
					used: [action.payload, ...state.data].reduce((acc, entity) => {
						acc = entity.types ? [...acc, ...entity.types.map((type) => type.id)] : acc
						return acc
					}, []),
				},
				loading: {
					...state.loading,
					update: false,
				},
			}
		case types.UPDATE_SYMPTOM_FAIL:
			return {
				...state,

				loading: {
					...state.loading,
					update: false,
				},
			}
		case types.UPDATE_SYMPTOM:
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.payload.new.id),

				loading: {
					...state.loading,
					update: true,
				},
			}

		// DELETE SYMPTOM
		case types.DELETE_SYMPTOM_SUCCESS:
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.payload.id),
				symptomTypes: {
					...state.symptomTypes,
					used: state.data.reduce((acc, entity) => {
						acc = entity.types ? [...acc, ...entity.types.map((type) => type.id)] : acc
						return acc
					}, []),
				},

				loading: {
					...state.loading,
					delete: false,
				},
			}
		case types.DELETE_SYMPTOM_FAIL:
			// if (wasOnline) {
			//   ToastHolder.showToast("error").alertWithContext(
			//     "Error",
			//     "Could Not Delete Entry!"
			//   );
			// }
			return {
				...state,

				loading: {
					...state.loading,
					delete: false,
				},
			}
		case types.DELETE_SYMPTOM:
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.payload.id),

				loading: {
					...state.loading,
					delete: true,
				},
			}

		// ADD SYMPTOM
		case types.ADD_SYMPTOM_SUCCESS:
			return {
				...state,
				data: storeItemsMerger(
					state.data,
					storeItemsTransactor(
						state,
						'data',
						action.payload,
						{
							id: action.payload.id,
						},
						symptomDecorator
					)
				),
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(state.symptomTypes.data, 'types', state.data, [
						'id',
						'name',
						'creator_id',
						'migration_id',
						'_app',
					]),
					used: [action.payload, ...state.data].reduce((acc, entity) => {
						acc = entity.types ? [...acc, ...entity.types.map((type) => type.id)] : acc
						return acc
					}, []),
				},
				loading: {
					...state.loading,
					create: false,
				},
			}
		case types.ADD_SYMPTOM_FAIL:
			return {
				...state,

				loading: {
					...state.loading,
					create: false,
				},
			}
		case types.ADD_SYMPTOM:
			return {
				...state,
				data: state.data.filter((item) => item._app.uuid !== action.payload._app.uuid),

				loading: {
					...state.loading,
					create: true,
				},
			}

		// GET SYMPTOM TYPES
		case types.GET_SYMPTOM_TYPES_SUCCESS:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(
						storeItemsMerger(
							state.symptomTypes.data,
							[
								...action.payload.local.map((local) => {
									local._app = {
										...local._app,
										type: 'local',
									}
									return local
								}),
								...action.payload.community.map((community) => {
									community._app = {
										...community._app,
										type: 'community',
									}
									return community
								}),
							]
								.map((entity) => {
									return storeItemsTransactor(state, 'symptomTypes.data', entity, {
										id: entity.id,
									})
								})
								.reduce((acc, current) => acc.concat(current), [])
						),
						'types',
						state.data,
						['id', 'name', 'creator_id', 'migration_id', '_app']
					),
					loading: {
						...state.symptomTypes.loading,
						read: false,
					},
				},
				searchCache: {
					...state.searchCache,
					symptomTypes: {
						...state.searchCache.symptomTypes,
						[action.meta.like || '']: {
							invoked_at: action.meta.invoked_at,
						},
					},
				},
			}

		case types.GET_SYMPTOM_TYPES_FAIL:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					loading: {
						...state.symptomTypes.loading,
						read: false,
					},
				},
			}

		case types.GET_SYMPTOM_TYPES:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					loading: {
						...state.symptomTypes.loading,
						read: true,
					},
				},
			}

		// UPDATE SYMPTOM TYPE
		case types.UPDATE_SYMPTOM_TYPE_SUCCESS:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(
						storeItemsMerger(
							state.symptomTypes.data,
							storeItemsTransactor(
								state,
								'symptomTypes.data',
								action.payload,
								{
									id: action.payload.id,
								},
								symptomTypeDecorator
							)
						),
						'types',
						state.data,
						['id', 'name', 'creator_id', 'migration_id', '_app']
					),

					loading: {
						...state.symptomTypes.loading,
						update: false,
					},
				},
			}

		case types.UPDATE_SYMPTOM_TYPE_FAIL:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,

					loading: {
						...state.symptomTypes.loading,
						update: false,
					},
				},
			}

		case types.UPDATE_SYMPTOM_TYPE:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: state.symptomTypes.data.filter((item) => item.id !== action.payload.id),

					loading: {
						...state.symptomTypes.loading,
						update: true,
					},
				},
			}

		// DELETE SYMPTOM TYPE
		case types.DELETE_SYMPTOM_TYPE_SUCCESS:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: state.symptomTypes.data.filter((type) => type.id !== action.payload.id),

					loading: {
						...state.symptomTypes.loading,
						delete: false,
					},
				},
			}

		case types.DELETE_SYMPTOM_TYPE_FAIL:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,

					loading: {
						...state.symptomTypes.loading,
						delete: false,
					},
				},
			}

		case types.DELETE_SYMPTOM_TYPE:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: state.symptomTypes.data.filter((item) => item.id !== action.payload.id),

					loading: {
						...state.symptomTypes.loading,
						delete: true,
					},
				},
			}

		// ADD SYMPTOM TYPE
		case types.ADD_SYMPTOM_TYPE_SUCCESS:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: storeChildTypeRanker(
						storeItemsMerger(
							state.symptomTypes.data,
							storeItemsTransactor(state, 'symptomTypes.data', action.payload, {
								id: action.payload.id,
							})
						),
						'types',
						state.data,
						['id', 'name', 'creator_id', 'migration_id', '_app']
					),

					loading: {
						...state.symptomTypes.loading,
						create: false,
					},
				},
			}

		case types.ADD_SYMPTOM_TYPE_FAIL:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,

					loading: {
						...state.symptomTypes.loading,
						create: false,
					},
				},
			}

		case types.ADD_SYMPTOM_TYPE:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					data: state.symptomTypes.data.filter((item) => {
						if (action.payload.id) {
							return item.id !== action.payload.id
						} else if (action.payload._app) {
							if (item._app) {
								return item._app.uuid !== action.payload._app.uuid
							}
						}
						return true
					}),

					loading: {
						...state.symptomTypes.loading,
						create: true,
					},
				},
			}

		// CURRENT SYMPTOM
		case types.CURRENT_SYMPTOM_SET:
			return { ...state, current: action.payload }

		case types.CURRENT_SYMPTOM_CLEAR:
			return { ...state, current: action.payload }

		case types.CURRENT_SYMPTOM_TYPE_ADD:
			return {
				...state,
				current: {
					...state.current,
					types: [...state.current.types, action.payload],
				},
			}

		case types.CURRENT_SYMPTOM_TYPE_REMOVE:
			return {
				...state,
				current: {
					...state.current,
					types: state.current.types.filter((type) => {
						if (type.id) {
							return type.id !== action.payload.id
						}
						if (type._app && action.payload._app) {
							return type._app.uuid !== action.payload._app.uuid
						}
					}),
				},
			}

		case types.RESET_SYMPTOM_LOADERS:
			return {
				...state,
				symptomTypes: {
					...state.symptomTypes,
					loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
				},
				loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
			}

		// case 'persist/REHYDRATE':
		//   if (action.payload.key === 'primary') {
		//     return {
		//       ...action.payload.symptom,
		//       symptomTypes: {
		//         ...action.payload.symptom.symptomTypes,
		//         loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
		//       },
		//       loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
		//     };
		//   }
		//   return state;

		case 'FAST_FORWARD_STORES':
			return deepMerge(JSON.parse(JSON.stringify(INITIAL_STATE)), state)

		case types.SCENE:
			return {
				...state,
				loading: JSON.parse(JSON.stringify(FALSY_LOADERS)),
			}

		case types.SYMPTOM_CONTEXT_RESET:
			return JSON.parse(JSON.stringify(INITIAL_STATE))

		// DEFAULT
		default:
			return state
	}
}
